module.exports = __webpack_public_path__ + "static/media/sykkel_gronn-min.1af9b46e.png";